<script setup>
import { computed } from 'vue'

const props = defineProps({
    url: {
        type: String,
        required: true,
    },
    text: {
        type: String,
        default: 'Check this out!',
    },
    showLabel: {
        type: Boolean,
        default: true,
    },
})

const encodedUrl = computed(() => encodeURIComponent(props.url))
const encodedText = computed(() => encodeURIComponent(props.text))

const shareLinks = computed(() => [
    {
        name: 'Twitter/X',
        url: `https://twitter.com/intent/tweet?text=${encodedText.value}&url=${encodedUrl.value}`,
        iconPath:
            'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
        color: 'hover:text-black dark:hover:text-white',
    },
    {
        name: 'Facebook',
        url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl.value}`,
        iconPath:
            'M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z',
        color: 'hover:text-[#1877F2]',
    },
    {
        name: 'LinkedIn',
        url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl.value}`,
        iconPath:
            'M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z', // simplified
        iconRect: true, // Needs a rect for the dot
        color: 'hover:text-[#0A66C2]',
    },
    {
        name: 'Reddit',
        url: `https://reddit.com/submit?url=${encodedUrl.value}&title=${encodedText.value}`,
        iconPath:
            'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11c-.55 0-1-.45-1-1 0-.24.08-.46.21-.64.13-.18.29-.36.29-.36s-.89-.47-2.5-.47c-1.61 0-2.5.47-2.5.47s.16.18.29.36c.13.18.21.4.21.64 0 .55-.45 1-1 1s-1-.45-1-1c0-.24.08-.46.21-.64-.53-.78-2.14-1.36-2.14-1.36s.2 1.36 1 2.29c-.04.23-.07.47-.07.71 0 3.31 2.69 6 6 6s6-2.69 6-6c0-.24-.03-.48-.07-.71.8-.93 1-2.29 1-2.29s-1.61.58-2.14 1.36c.13.18.21.4.21.64 0 .55-.45 1-1 1z',
        color: 'hover:text-[#FF4500]',
    },
])
</script>

<template>
    <div class="c-share">
        <span v-if="showLabel" class="c-share__label">Share:</span>
        <a
            v-for="link in shareLinks"
            :key="link.name"
            :href="link.url"
            target="_blank"
            rel="noopener noreferrer"
            class="c-share__link"
            :class="link.color"
            :aria-label="`Share on ${link.name}`"
        >
            <svg
                class="c-share__icon"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path :d="link.iconPath" />
                <rect v-if="link.iconRect" x="2" y="3" width="4" height="4" />
            </svg>
        </a>
    </div>
</template>
